@if (introVisible()) {
  <div
    class="hw-intro"
    [class.hw-intro-leaving]="introLeaving()"
    aria-hidden="true">
    <div class="hw-dim"></div>
    <div class="hw-moon"></div>
    <div class="hw-fog hw-fog-back"></div>
    <div class="hw-fog hw-fog-front"></div>
    <div class="hw-spider">
      <svg class="hw-spider-body" viewBox="0 0 60 60">
        <g class="hw-spider-legs">
          <path d="M24 26 C14 18 8 20 3 12 M24 30 C12 28 6 30 1 26 M24 34 C12 36 7 42 2 46 M26 37 C18 44 14 50 12 58" />
          <path d="M36 26 C46 18 52 20 57 12 M36 30 C48 28 54 30 59 26 M36 34 C48 36 53 42 58 46 M34 37 C42 44 46 50 48 58" />
        </g>
        <ellipse cx="30" cy="34" rx="9" ry="10" />
        <circle cx="30" cy="22" r="6" />
        <circle class="hw-spider-eye" cx="27.5" cy="21" r="1.4" />
        <circle class="hw-spider-eye" cx="32.5" cy="21" r="1.4" />
      </svg>
    </div>
    @for (bat of introBats(); track bat.id) {
      <div class="hw-bat" [style]="bat.style">
        <ng-container [ngTemplateOutlet]="batShape" />
      </div>
    }
    <div class="hw-greeting">
      <div class="hw-greeting-title">Happy Halloween</div>
      <div class="hw-greeting-subtitle">from all of us at TIDY</div>
    </div>
  </div>
}

@for (bat of finaleBats(); track bat.id) {
  <div class="hw-bat hw-bat-finale" [style]="bat.style" aria-hidden="true">
    <ng-container [ngTemplateOutlet]="batShape" />
  </div>
}

@if (pumpkinSpot(); as spot) {
  <button
    type="button"
    class="hw-pumpkin"
    [class.hw-pumpkin-right]="spot.position === 'right'"
    [class.hw-pumpkin-top]="spot.position === 'top'"
    [class.hw-pumpkin-popping]="poppingPumpkin()"
    [style.--hw-offset]="spot.offset"
    aria-label="You found a hidden pumpkin"
    (click)="findPumpkin($event)">
    @if (spot.position === 'top') {
      <span class="hw-pumpkin-vine"></span>
    }
    <svg class="hw-pumpkin-shape" viewBox="0 0 64 60">
      <path class="hw-pumpkin-stem" d="M30 12 C29 6 31 2 36 1 C35 5 34 8 35 13 Z" />
      <ellipse class="hw-pumpkin-rib" cx="18" cy="36" rx="14" ry="20" />
      <ellipse class="hw-pumpkin-rib" cx="46" cy="36" rx="14" ry="20" />
      <ellipse class="hw-pumpkin-core" cx="32" cy="36" rx="14" ry="22" />
      <path class="hw-pumpkin-face" d="M22 31 L27 25 L30 32 Z M42 31 L37 25 L34 32 Z M20 40 C26 48 38 48 44 40 L40 42 L38 39 L35 43 L32 40 L29 43 L26 39 L24 42 Z" />
    </svg>
  </button>
}

@if (ghostVisible()) {
  <div class="hw-ghost" aria-hidden="true">
    <div class="hw-ghost-bubble">BOO!</div>
    <svg class="hw-ghost-body" viewBox="0 0 80 96">
      <path d="M40 4 C18 4 8 22 8 42 L8 88 L18 80 L28 90 L40 80 L52 90 L62 80 L72 88 L72 42 C72 22 62 4 40 4 Z" />
      <ellipse class="hw-ghost-eye" cx="29" cy="38" rx="5" ry="7" />
      <ellipse class="hw-ghost-eye" cx="51" cy="38" rx="5" ry="7" />
      <ellipse class="hw-ghost-eye" cx="40" cy="58" rx="6" ry="8" />
    </svg>
  </div>
}

@if (caption(); as text) {
  <div class="hw-caption" role="status">{{ text }}</div>
}

<ng-template #batShape>
  <svg class="hw-bat-shape" viewBox="0 0 100 50">
    <path class="hw-bat-wing" d="M46 22 C38 10 22 6 4 12 C10 16 12 20 12 24 C18 20 22 22 24 27 C28 23 34 24 36 30 C40 26 44 27 46 30 Z" />
    <path class="hw-bat-wing" d="M54 22 C62 10 78 6 96 12 C90 16 88 20 88 24 C82 20 78 22 76 27 C72 23 66 24 64 30 C60 26 56 27 54 30 Z" />
    <path d="M46 14 L45 6 L49 11 Z M54 14 L55 6 L51 11 Z" />
    <circle cx="50" cy="16" r="5" />
    <ellipse cx="50" cy="27" rx="5" ry="9" />
    <circle class="hw-bat-eye" cx="48" cy="15.5" r="1" />
    <circle class="hw-bat-eye" cx="52" cy="15.5" r="1" />
  </svg>
</ng-template>
